<template>
  <v-app-bar app>
    <v-toolbar-title class="d-flex align-center">
      <a href="/">
        <v-img 
          contain 
          class="shrink ml-6 mr-2"
          width="30"
          src="../assets/favicon.png"
        />
      </a>
      
      <a href="/">
        <span id="tao">Tao</span>
        <span id="chin">Chin</span>
      </a>
    </v-toolbar-title>
  
    <v-spacer></v-spacer>

    <v-btn text>
      <router-link 
        to="/"
        style="text-decoration: none"
      >
        主页
      </router-link>
    </v-btn> 
  
    <menu-course></menu-course>
    <menu-contest></menu-contest>

    <v-btn v-for="btn in btns" :key="btn.link" text>
      <router-link 
        :to="btn.link"
        style="text-decoration: none"
      >
        {{ btn.page }}
      </router-link>
    </v-btn> 

    <menu-search></menu-search>

    <v-spacer></v-spacer>
    
  </v-app-bar>
</template>

<script>
import MenuCourse from './atoms/MenuCourse.vue';
import MenuSearch from './atoms/MenuSearch.vue';

export default{
  name: "MyHeader",
  components: {
    MenuCourse,
    MenuSearch,
  },
  data() {
    return {
      btns: [
        { 
          page: "国际竞赛",
          link: "/paper-bank/Contests" 
        },{ 
          page: "牛剑入学考",
          link: "/paper-bank/Uni-Admissions" 
        },
      ],
    };
  },
}
</script>

<style scoped>
.router-link-active{
  text-decoration: none;
}
#tao{
  /* margin-left: 3em; */
  font-size: larger;
  font-weight: bold;
  color: black;
}
#chin{
  font-size: larger;
  font-weight: bold;
  color: red;
}
a{
  text-decoration: none;
}
</style>